// components/Logo.js
import React from "react";

export default function Logo() {
  return <h1>🌲🌲 PACK YOUR ITEMS 💼</h1>;
}
